import classNames from 'classnames';
import React, { FC } from 'react';
import { AttendeeConnectionVariant } from '../../../constans/attendee-enums';

interface IProps {
    onClick: () => void;
    disabled: boolean;
    hidden: boolean;
    shouldRender: boolean;
    label: string;
}

const ChangeConnectionStatusButton: FC<IProps> = ({ disabled, hidden, shouldRender, onClick, label }) => {
  if(!shouldRender) {
    return null;
  }
  const className = classNames('connection-control-btn', {
    'disabled': disabled,
    'hidden': hidden,
    'blue': label === AttendeeConnectionVariant.RECONNECT,
    'red': label === AttendeeConnectionVariant.DISCONNECT
  });

  return <button className={className} onClick={onClick}>{label}</button>;
};

export { ChangeConnectionStatusButton };